// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenu_tabMenu__UWk4q","tabs":"TabMenu_tabs__O5wHW","tab":"TabMenu_tab__504g7","active":"TabMenu_active__3vRNo"};